import { useMutation, useQuery } from 'react-query';
import { useCallback } from 'react';
import { getAPI } from '../../services/API';
import useRequestConfig from './useRequestConfig';
import { queryClient } from '../../services/queryClient';
import { sdkErrorHandler } from '../../utils';
import { useSelector } from 'react-redux';
import { userTokenSelector } from '../../redux/reducers/app/params';

export const RECENT_GAMES_QUERY_KEY = 'RECENT_GAMES_QUERY_KEY';

export const useQueryRecentGames = (queryOptions = {}) => {
  const requestConfig = useRequestConfig();
  // for cases when user logged out
  const token = useSelector(userTokenSelector);

  const select = useCallback(
    (data) => {
      const transformedToRegularDTO = data.map((game) => {
        const { lobbyId, provider, translationKey } = game;
        return {
          id: lobbyId,
          provider,
          translationKey,
        };
      });

      if (queryOptions.select) {
        return queryOptions.select(transformedToRegularDTO);
      }

      return transformedToRegularDTO;
    },
    [queryOptions]
  );
  const fetch = ({ signal }) =>
    getAPI()
      .games.getRecents({ signal, ...requestConfig })
      .catch(
        sdkErrorHandler({
          ...requestConfig,
          queryOptions,
          source: `SDK API games.getRecents`,
        })
      );

  return useQuery([RECENT_GAMES_QUERY_KEY, token], fetch, {
    ...queryOptions,
    select,
  });
};

export const useMutationUploadRecents = (ids = [], mutationOptions = {}) => {
  const requestConfig = useRequestConfig();

  const fetch = () => getAPI().games.addRecents(ids, { ...requestConfig });

  const onSuccess = useCallback(async () => {
    await queryClient.refetchQueries(RECENT_GAMES_QUERY_KEY);
    if (mutationOptions.onSuccess) {
      mutationOptions.onSuccess?.();
    }
  }, [mutationOptions]);

  return useMutation(fetch, { ...mutationOptions, onSuccess });
};
